import React, { useState } from 'react';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { Drawer as MuiDrawer, styled } from '@mui/material';

import TooltipButton from '../../../../../../components/tooltip-button/TooltipButton';
import RequestsHistory from '../../../../../../ai-studio/requests-history/RequestsHistory';
import Icon from '../../../../../../icons/Icon';
import CommonIconButton from '../../../../../../components/common-icon-button/CommonIconButton';
import { ICONS } from '../../../../../../icons';
import usePredefineOptions from '../../../../hooks/usePredefineOptions';

import scss from './HistoryDrawer.module.scss';

function HistoryDrawer() {
  const [isOpen, setIsOpen] = useState(false);

  const actionOptions = usePredefineOptions();

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <>
      <TooltipButton maxWidth={32} onClick={handleOpen}>
        <Icon icon={HistoryOutlinedIcon} />
      </TooltipButton>
      <Drawer open={isOpen} hidden={!isOpen} anchor='right' onClose={handleClose} variant='temporary'>
        <div className={scss.header}>
          <CommonIconButton icon={ICONS.Cross} onClick={handleClose} className={scss.closeButton} isStrokeIcon />
        </div>
        <RequestsHistory actionOptions={actionOptions.options} />
      </Drawer>
    </>
  );
}

export default HistoryDrawer;

const Drawer = styled(MuiDrawer)({
  '& .MuiDrawer-paper': {
    background: 'var(--sidebar-bg)',
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
    padding: '1rem',
    width: '400px',
  },
  '& .MuiBackdrop-root': {
    opacity: '0 !important',
  },
});
